import React from 'react'

import { BaseText } from '@/components/base'

interface FlagLockedProps {
  fontSize?: number
}

export const FlagLocked: React.FC<FlagLockedProps> = ({ fontSize = 16 }) => {
  return (
    <BaseText fontSize={fontSize} fontFamily="medium" color="label.error">
      Locked
    </BaseText>
  )
}
